import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { cn } from '@/utils/cn';
import { getStockAddableQuantity } from '@/utils/number';
import { LIST_VIEW } from '@/constants';
import TextExtraSmall from '@/app/components/Typography/TextExtraSmall';
import TextSmall from '@/app/components/Typography/TextSmall';

function ProductStockStatus({
  productData,
  isCard = false,
  viewType = LIST_VIEW,
}) {
  const { items: cart } = useSelector((state) => state.carts);

  const [currentStock, setCurrentStock] = useState(
    productData?.limited_stock ? 0 : productData?.max_cart_quantity,
  );

  useEffect(() => {
    const stockUpdate = getStockAddableQuantity({
      cart,
      productId: productData?.id,
      maxQuantity: productData?.max_cart_quantity,
      productData,
    });

    setCurrentStock(() => stockUpdate);
  }, [cart, productData]);

  if (isCard) {
    return (
      <div className="flex items-center h-[32px] lg:h-[32px]">
        <TextExtraSmall
          text={
            productData?.limited_stock || currentStock <= 0
              ? 'Limited Stock!'
              : null
          }
          className={cn('font-semibold hidden !text-xss lg:!text-xs', {
            '!text-xss lg:!text-sm lg:leading-5 lg:my-0':
              viewType === LIST_VIEW,
            'text-burning-tomato flex':
              productData?.limited_stock || currentStock <= 0,
          })}
        />
      </div>
    );
  }

  return (
    <>
      {productData?.limited_stock || currentStock <= 0 ? (
        <div className="border-[1px] border-himalayan-poppy h-[12px]" />
      ) : null}

      <TextSmall
        text={
          productData?.limited_stock || currentStock <= 0
            ? 'Limited Stock!'
            : null
        }
        className={cn(
          'text-burning-tomato font-semibold tracking-[0.24px] lg:tracking-[0.32px]',
          {
            'text-burning-tomato':
              productData?.limited_stock || currentStock <= 0,
          },
        )}
      />
    </>
  );
}

export default ProductStockStatus;
